import { ParamMap } from '@angular/router';

export interface RouteIdResult {
  isValid: boolean;
  id?: string;
}

export const idFromRoute = (paramMap: ParamMap | undefined): RouteIdResult => {
  const id = paramMap?.get('id');
  if (!id) {
    return { isValid: false };
  }

  //UUID v1–v5 regex
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  return uuidRegex.test(id) ? { isValid: true, id } : { isValid: false };
};
